import { render, staticRenderFns } from "./award.vue?vue&type=template&id=4e300e7e&"
import script from "./award.vue?vue&type=script&lang=js&"
export * from "./award.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports